import { DataAttributeDefinitions, provideDataItem } from "scrivito"
import { UserKpi } from "shared/types/__generated__/graphql"

import { apolloClient } from "app/apolloRestLink"

import {
  UserKpiDocument,
  UserKpiQuery
} from "features/kpi/graphql/queries.generated"
import I18n from "i18next"

async function attributes(): Promise<DataAttributeDefinitions> {
  return {
    totalUsers: [
      "number",
      { title: I18n.t("editing:attributes.KPIs.users.count.total.title") }
    ],
    totalInternalUsers: [
      "number",
      { title: I18n.t("editing:attributes.KPIs.users.count.internal.title") }
    ],
    totalExternalUsers: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.count.external.total.title"
        )
      }
    ],
    totalRegistrations: [
      "number",
      {
        title: I18n.t("editing:attributes.KPIs.users.registrations.total.title")
      }
    ],
    linkedinUsers: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.count.external.linkedin.title"
        )
      }
    ],
    microsoftUsers: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.count.external.microsoft.title"
        )
      }
    ],
    googleUsers: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.count.external.google.title"
        )
      }
    ],
    emailUsers: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.count.external.email.title"
        )
      }
    ],
    externalActiveUsers: [
      "number",
      {
        title: I18n.t("editing:attributes.KPIs.users.active.external.title")
      }
    ],
    externalLoginLast7Days: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.dailyOverview.login.last7Days.title"
        )
      }
    ],
    externalLoginLast30Days: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.dailyOverview.login.last30Days.title"
        )
      }
    ],
    externalSignUpLast7Days: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.dailyOverview.signup.last7Days.title"
        )
      }
    ],
    externalSignUpLast30Days: [
      "number",
      {
        title: I18n.t(
          "editing:attributes.KPIs.users.dailyOverview.signup.last30Days.title"
        )
      }
    ]
  }
}

export const UserKpiDataItem = provideDataItem("UserKPIs", {
  attributes,
  connection: {
    async get() {
      let userKPIsData: UserKpi | null | undefined

      try {
        userKPIsData = await apolloClient
          .query<UserKpiQuery>({
            query: UserKpiDocument
          })
          .then(res => {
            return res.data.userKpi
          })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch user KPIs!", error)
      }

      return {
        totalUsers: userKPIsData?.usersCount.total,
        totalInternalUsers: userKPIsData?.usersCount.internal,
        totalExternalUsers: userKPIsData?.usersCount.external,
        totalRegistrations: userKPIsData?.registrations.total,

        linkedinUsers: userKPIsData?.registrations.linkedin,
        microsoftUsers: userKPIsData?.registrations.microsoft,
        googleUsers: userKPIsData?.registrations.google,
        emailUsers: userKPIsData?.registrations.email,

        externalActiveUsers: userKPIsData?.activeUsers.external,
        externalLoginLast7Days:
          userKPIsData?.dailyOverview.external.last7.logins,
        externalLoginLast30Days:
          userKPIsData?.dailyOverview.external.last30.logins,
        externalSignUpLast7Days:
          userKPIsData?.dailyOverview.external.last7.signups,
        externalSignUpLast30Days:
          userKPIsData?.dailyOverview.external.last30.signups
      }
    }
  }
})
